import { render } from "./Home.vue?vue&type=template&id=12d48c54"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render

export default script